module.exports = __webpack_public_path__ + "media/images/narrow-c5bc82f7.svg";